import React, { useState, useEffect, useContext } from "react";
import { Routes, Route } from "react-router-dom";

import ContextComponent from "../../AppContext";
import Utils from "../../Utils";
import Userpage from "./users/Userpage";
import Sitespage from "./sites/Sitespage";
import SitePage from "./sites/SitePage";
import SectionPage from "./sites/site/Section";
import SettingsPage from "./settings/SettingsPage";
import AddSitePage from "./sites/AddSitePage";
import EditSitePage from "./sites/EditSitePage";
import SectionReportsPage from "./sectionreports/SectionReportsPage";
import ProjectSitesPage from "./sites/ProjectSitesPage";
import GlobalReportsPage from "./reports/GlobalReportsPage";

const ContentArea = () => {
  let [admin, setAdmin] = useState(false);
  let [superAdmin, setSuperAdmin] = useState(false);

  let { userData } = useContext(ContextComponent);

  useEffect(() => {
    setAdmin(!!userData?.admin);
    setSuperAdmin(!!userData?.superAdmin);
  }, [admin, superAdmin, userData]);
  return (
    <Routes>
      {admin && (
        <Route
          path={Utils.APP_URLS.USERS_PAGE}
          exact
          element={<Userpage />}
        ></Route>
      )}
      <Route
        path={Utils.APP_URLS.SITE_REPORTS_PAGE}
        exact
        element={<SectionReportsPage />}
      ></Route>
      {
        <Route
          path={Utils.APP_URLS.GLOBAL_REPORTS_PAGE}
          exact
          element={<GlobalReportsPage />}
        ></Route>
      }
      <Route
        path={Utils.APP_URLS.SETTINGS_PAGE}
        exact
        element={<SettingsPage />}
      ></Route>

      <Route
        path={Utils.APP_URLS.ADD_SITE_PAGE}
        exact
        element={<AddSitePage />}
      ></Route>

      {/* <Route
        path={Utils.APP_URLS.SITES_PAGE}
        exact
        element={<Sitespage />}
      ></Route> */}

      {/* <Route
        path={Utils.APP_URLS.SECTION_PAGE}
        exact
        element={<SectionPage />}
      ></Route> */}

      <Route
        path={Utils.APP_URLS.PROJECT_SECTION_PAGE}
        exact
        element={<SectionPage />}
      ></Route>

      {/* <Route
        path={Utils.APP_URLS.SITE_PAGE}
        exact
        element={<SitePage />}
      ></Route> */}

      <Route
        path={Utils.APP_URLS.PROJECT_SITE_PAGE}
        exact
        element={<SitePage />}
      ></Route>

      {/* <Route
        path={Utils.APP_URLS.EDIT_SITE_PAGE}
        exact
        element={<EditSitePage />}
      ></Route> */}

      <Route
        path={Utils.APP_URLS.PROJECT_EDIT_SITE_PAGE}
        exact
        element={<EditSitePage />}
      ></Route>

      <Route
        path={Utils.APP_URLS.LANDING_PAGE}
        exact
        element={<ProjectSitesPage />}
      ></Route>
      <Route
        path={`${Utils.APP_URLS.PROJECTS_PAGE}/*`}
        exact
        element={<ProjectSitesPage />}
      ></Route>
      <Route path={`/*`} exact element={<ProjectSitesPage />}></Route>
    </Routes>
  );
};

export default ContentArea;
